import { Component, Input, Output, EventEmitter } from '@angular/core';
import { ContextoPWA } from '@core/context/services/mobile-context.service';
import { ItemEducacionalColorService } from '@core/context/services/item-educacional-color.service';

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html'
})
export class SidebarComponent {
  @Input() isOpen = false;
  @Input() contexto: ContextoPWA | null = null;
  @Input() contextActionLabel = '';
  @Input() userPhoto: string | null = null;
  @Input() userName = '';
  @Input() userLogin = '';
  @Input() planoEnsinoDisponivel = false;
  
  @Output() closeMenu = new EventEmitter<void>();
  @Output() abrirContexto = new EventEmitter<void>();
  @Output() abrirConfiguracoes = new EventEmitter<void>();
  @Output() logout = new EventEmitter<void>();

  contextoExpandido = false;

  constructor(private colorService: ItemEducacionalColorService) {}

  onCloseMenu(): void {
    this.closeMenu.emit();
  }

  toggleContexto(): void {
    this.contextoExpandido = !this.contextoExpandido;
  }

  abrirModalContexto(): void {
    this.abrirContexto.emit();
  }

  abrirModalConfiguracoes(): void {
    this.abrirConfiguracoes.emit();
  }

  onLogout(): void {
    this.logout.emit();
  }

  getComponentesLength(): number {
    return this.contexto?.componentes?.length || 0;
  }

  getComponenteColor(componente: { id: number; color?: string }, index: number): string {
    return this.colorService.getColorFromClassName(componente.color) ?? this.colorService.getColorByIndex(index);
  }
}
